import {
  KYDAdminEvent,
  KYDAdminEventDetailSection,
} from "@common/interfaces/KYDEvent";
import { sectionsComponents } from "./sectionsComponents";
import { Stack } from "@chakra-ui/react";
import { EditModalType } from "src/utils";
import React from "react";
import ErrorBoundary from "./ErrorBoundary";

const EventDetailSections = ({
  sections = [],
  onUpdateEvent,
  setModalType,
  modalType,
  isLoading,
  refetchEvent,
  pollForEventUpdateStatus,
}: {
  sections: KYDAdminEventDetailSection[];
  modalType?: EditModalType;
  isLoading: boolean;
  onUpdateEvent: (key: string, override_value?: string) => Promise<void>;
  setModalType: (value: React.SetStateAction<EditModalType>) => void;
  refetchEvent?: (options: any) => Promise<KYDAdminEvent>;
  pollForEventUpdateStatus: () => Promise<boolean>;
}) => {
  return (
    <Stack spacing={{ base: "8", lg: "10" }} maxW={["full", "5xl"]} w="full">
      {sections.map((section) => {
        const Component = sectionsComponents[section.type];
        if (!Component) {
          console.warn(
            `Skipping rendering ${section.type}. No component ${section.type} supported.`
          );
          return null;
        }

        return (
          <ErrorBoundary key={section.type}>
            <Component
              data={section.data}
              permissions={section.permissions}
              isLoading={isLoading}
              modalType={modalType}
              refetchEvent={refetchEvent}
              setModalType={setModalType}
              onUpdateEvent={onUpdateEvent}
              pollForEventUpdateStatus={pollForEventUpdateStatus}
            />
          </ErrorBoundary>
        );
      })}
    </Stack>
  );
};

export default EventDetailSections;
